import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { CatalogManufacturer, PartKind, PartTransactionType } from './types';

export const PART_KIND_LABEL: Record<PartKind, string> = {
  ACCESSORY: 'Accessory',
  REPAIR_PART: 'Repair part',
};

export const PART_KIND_DESCRIPTION: Record<PartKind, string> = {
  ACCESSORY: 'Keyboards, mice, docks, and chargers you hand out to people and rooms',
  REPAIR_PART: 'Screens, batteries, and other spares used to repair devices',
};

export const PART_TRANSACTION_LABEL: Record<PartTransactionType, string> = {
  RECEIVED: 'Received',
  ASSIGNED: 'Assigned',
  RETURNED: 'Returned',
  USED: 'Used in repair',
  PUT_BACK: 'Put back',
  ADJUSTED: 'Stock count',
};

/** The school's manufacturers, each with its models. */
export const useCatalog = () =>
  useQuery({ queryKey: ['catalog'], queryFn: () => api.get<CatalogManufacturer[]>('/manufacturers'), staleTime: 60_000 });

/** "Dell Latitude 5450", without doubling names like "Dell Dell Chromebook 3110". */
export function modelLabel(model: { name: string; manufacturer: { name: string } }) {
  return model.name.toLowerCase().startsWith(model.manufacturer.name.toLowerCase())
    ? model.name
    : `${model.manufacturer.name} ${model.name}`;
}
